import { render, staticRenderFns } from "./TermConsultation.vue?vue&type=template&id=1a4340d8&"
import script from "./TermConsultation.vue?vue&type=script&lang=js&"
export * from "./TermConsultation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports